<template>
  <div>
    <div class="tabs">
      <ul>
        <li v-for="(tab, idx) in tabs" :key="idx" :class="{'is-active' : tab.isActive}">
          <a @click="selectTab(tab)">{{tab.name}}</a>
        </li>
      </ul>
    </div>
    <div>
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: "show-tabs",
  data() {
    return {
      tabs: []
    };
  },
  created() {
    this.tabs = this.$children;
  },
  methods: {
    selectTab(selectedTab) {
      this.tabs.forEach(tab => {
        tab.isActive = tab.name === selectedTab.name;
      });
    }
  }
};
</script>